export default {
  // Colors go from ligthest to darkest
  colors: {
    backgroundColor: '#F6F5FC',
    primary: {
      lighter: '#44C9FA',
      light: '#2597F5',
      main: '#075BF0',
      dark: '#0322D6',
      darker: '#0B00BA',
    },
    gray: {
      athens: '#E9ECEF',
      geyser: '#DEE2E6',
      ghost: '#CED4DA',
      hit: '#ADB5BD',
      oslo: '#868E96',
      trout: '#495057',
      shark: '#212529',
    },
    error: '#EB5757',
    success: '#27AE60',
    warning: '#FAB005',
  },
};
